/* NOK Collection Carousel
   Progressive enhancement: arrow buttons, progress bar, editor support, and (opt-in via
   data attributes on .nok-cc) shuffle-on-load and gentle auto-rotate.
   The carousel itself is native CSS scroll-snap, so it works without this file. */
(function () {
  if (customElements.get('nok-collection-carousel')) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  class NokCollectionCarousel extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.nok-cc');
      this.track = this.querySelector('.nok-cc__track');
      this.prev = this.querySelector('[data-nok-cc-prev]');
      this.next = this.querySelector('[data-nok-cc-next]');
      this.thumb = this.querySelector('.nok-cc__progress-thumb');
      if (!this.track) return;

      // Optional: random order on every page load (skipped inside the theme editor).
      if (this.root && this.root.dataset.shuffle === 'true' && !designMode) this.shuffle();
      if (this.root) this.root.setAttribute('data-ready', 'true');

      this.userAt = 0;
      this.hovering = false;
      this.inView = true;

      this.onScroll = () => this.requestUpdate();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      var touch = () => { this.userAt = Date.now(); };
      if (this.prev) this.prev.addEventListener('click', () => { touch(); this.page(-1); });
      if (this.next) this.next.addEventListener('click', () => { touch(); this.page(1); });
      ['touchstart', 'wheel', 'keydown', 'pointerdown'].forEach((evt) => {
        this.addEventListener(evt, touch, { passive: true });
      });
      this.addEventListener('mouseenter', () => { this.hovering = true; });
      this.addEventListener('mouseleave', () => { this.hovering = false; });
      this.addEventListener('focusin', () => { this.hovering = true; });
      this.addEventListener('focusout', () => { this.hovering = false; });

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => this.requestUpdate());
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this.onScroll);
      }

      // Theme editor: bring a selected card into view.
      this.onBlockSelect = (event) => {
        const slide = event.target;
        if (!slide || !this.track.contains(slide)) return;
        const left = slide.offsetLeft - this.track.offsetLeft;
        this.track.scrollTo({ left: left, behavior: 'smooth' });
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.update();
      this.setupAutoplay();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.viewObserver) this.viewObserver.disconnect();
      if (this.timer) clearInterval(this.timer);
      window.removeEventListener('resize', this.onScroll);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    shuffle() {
      var slides = Array.prototype.slice.call(this.track.children);
      for (var i = slides.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = slides[i];
        slides[i] = slides[j];
        slides[j] = tmp;
      }
      slides.forEach((slide) => this.track.appendChild(slide));
    }

    setupAutoplay() {
      var seconds = this.root ? parseFloat(this.root.dataset.autoplay) : 0;
      if (!seconds || seconds <= 0 || reduceMotion || designMode) return;

      if (window.IntersectionObserver) {
        this.viewObserver = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
        }, { threshold: 0.2 });
        this.viewObserver.observe(this);
      }

      var interval = seconds * 1000;
      this.timer = setInterval(() => this.tick(interval), interval);
    }

    tick(interval) {
      if (document.hidden || this.hovering || !this.inView) return;
      // Someone just used the carousel: leave it alone for a while.
      if (Date.now() - this.userAt < interval * 1.5) return;
      var max = this.track.scrollWidth - this.track.clientWidth;
      if (max <= 4) return;
      if (this.track.scrollLeft >= max - 4) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.page(1);
      }
    }

    requestUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    gap() {
      return parseFloat(getComputedStyle(this.track).columnGap) || 0;
    }

    step() {
      const slide = this.track.querySelector('.nok-cc__slide');
      if (!slide) return this.track.clientWidth;
      return slide.getBoundingClientRect().width + this.gap();
    }

    page(direction) {
      const step = this.step();
      // N cards plus N-1 gaps fill the row, so add one gap before dividing.
      const visible = Math.max(1, Math.floor((this.track.clientWidth + this.gap() + 4) / step));
      this.track.scrollBy({ left: direction * step * visible, behavior: 'smooth' });
    }

    update() {
      const track = this.track;
      const max = track.scrollWidth - track.clientWidth;
      const x = track.scrollLeft;
      const scrollable = max > 4;

      if (this.root) this.root.setAttribute('data-scrollable', scrollable ? 'true' : 'false');
      if (this.prev) this.prev.disabled = x <= 2;
      if (this.next) this.next.disabled = x >= max - 2;

      if (this.thumb && scrollable) {
        const width = Math.max(12, (track.clientWidth / track.scrollWidth) * 100);
        const offset = (x / max) * (100 - width);
        this.thumb.style.setProperty('--nok-cc-thumb-w', width + '%');
        this.thumb.style.setProperty('--nok-cc-thumb-x', offset + '%');
      }
    }
  }

  customElements.define('nok-collection-carousel', NokCollectionCarousel);
})();
